// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const MyDayPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-mydaypage" */ "./MyDayPage")).then((bundle)=>{
        return {
            default: bundle.MyDayPage
        };
    });
export const LazyMyDayPage = /*#__PURE__*/ lazy(MyDayPageLazyLoader);
